import * as angular from "angular";

const actionTypes = [
  {type: 'TakePicture'},
  {type: 'TakeVideo'},
  {type: 'Signature'},
  {type: 'FreeText'},
  {type: 'DocumentScan'},
  {type: 'BarcodeScan'},
  {type: 'BarcodePairing'},
  {type: 'FileUpload'},
  {type: 'Collect'},
  {type: 'Payment'},
  {type: 'PdfForm'},
  {type: 'Dropdown', dropdownOptions: []}
]

angular
  .module('bringoz.admin.sub-tasks')
  .constant('SubTasksConstants', {
    actionTypes: actionTypes
  });
